import { render, staticRenderFns } from "./giftcard-options.vue?vue&type=template&id=1b03f332"
import script from "./giftcard-options.vue?vue&type=script&lang=js"
export * from "./giftcard-options.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports